const StoreImages = `
    imgs,            store_images;
    mimg,            store_mobile_image;
    himg,            store_header_image;
    logo,            store_logo;
    logo-png,        store_qr_logo;
`

export default StoreImages;